var $7766b8cb542dd7d4$exports = {};
$7766b8cb542dd7d4$exports = {
    "endTime": `Endzeit`,
    "startTime": `Startzeit`,
    "time": `Uhrzeit`
};


export {$7766b8cb542dd7d4$exports as default};
//# sourceMappingURL=de-DE.module.js.map
